import axios from 'axios'
import Auth from '@/services/Auth'

const Claim = axios.create({ baseURL: `${process.env.VUE_APP_ROOT_API}` })
const Account = axios.create({ baseURL: `${process.env.VUE_APP_ROOT_API}` })
const Coverage = axios.create({ baseURL: `${process.env.VUE_APP_ROOT_API}` })
const Envelope = axios.create({ baseURL: `${process.env.VUE_APP_ROOT_API}` })
const Api = axios.create({ baseURL: `${process.env.VUE_APP_ROOT_API}` })
const Document = axios.create({ baseURL: `${process.env.VUE_APP_ROOT_API}` })

Claim.interceptors.request.use(
  function (config) {
    const token = Auth.getToken('Claim')
    if (token) config.headers['apikey'] = token
    config.params = { appSource: 'sic-portal', ...config.params }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

Account.interceptors.request.use(
  function (config) {
    const token = Auth.getToken('Account')
    if (token) config.headers['apikey'] = token
    config.params = { appSource: 'sic-portal', ...config.params }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

Coverage.interceptors.request.use(
  function (config) {
    let token = Auth.getToken('Coverage')
    if (!token) {
      token = Auth.getToken('Claim')
    }
    if (token) config.headers['apikey'] = token
    config.params = { appSource: 'sic-portal', ...config.params }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

Envelope.interceptors.request.use(
  function (config) {
    const token = Auth.getToken('ICE')
    if (token) config.headers['apikey'] = token
    config.params = { appSource: 'sic-portal', ...config.params }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

Api.interceptors.request.use(
  function (config) {
    const token = Auth.getUserRegistrationToken()
    if (token) config.headers['x-r-token'] = token
    config.params = { appSource: 'sic-portal', ...config.params }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

Document.interceptors.request.use(
  function (config) {
    let token = Auth.getToken('Coverage')
    if (!token) {
      token = Auth.getToken('Claim')
    }
    if (token) config.headers['apikey'] = token
    config.params = { appSource: 'sic-portal', ...config.params }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

const removeEmptyKeys = function (obj) {
  for (const key of Object.keys(obj)) {
    if (!obj[key] || obj[key] === '') {
      delete obj[key]
    }
  }
  return obj
}

export default {
  Claim,
  Account,
  Coverage,
  Envelope,
  Api,
  Document,
  removeEmptyKeys
}
